const Skeleton = () => {
  return (
    <div tw="bg-white shadow rounded-xl max-w-lg flex flex-col items-center gap-6 p-2 md:p-6 pt-2">
      {/* Header avec état, batterie, refresh et reboot */}
      <div tw="flex flex-col xs:flex-row bg-white items-center justify-between w-full">
        <div tw="flex items-center gap-8 bg-gray-50 rounded-lg shadow p-2 animate-pulse">
          {/* État */}
          <div tw="flex items-center gap-2 w-[120px]">
            <div tw="w-3 h-3 bg-gray-300 rounded-full" />
            <div tw="w-20 h-5 bg-gray-300 rounded" />
          </div>
          {/* Batterie */}
          <div tw="flex items-center gap-2">
            <div tw="w-5 h-5 bg-gray-300 rounded" />
            <div tw="w-10 h-5 bg-gray-300 rounded" />
          </div>
        </div>
        {/* Boutons refresh et reboot */}
        <div tw="flex flex-row items-center gap-4 p-2">
          <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2 min-w-[100px]">
            <div tw="w-5 h-5 bg-gray-300 rounded" />
            <div tw="w-12 h-4 bg-gray-300 rounded" />
          </div>
          <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2 min-w-[100px]">
            <div tw="w-5 h-5 bg-gray-300 rounded" />
            <div tw="w-12 h-4 bg-gray-300 rounded" />
          </div>
        </div>
      </div>

      {/* Zone pantographe */}
      <div tw="w-full max-w-80 h-60 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center">
        <div tw="w-48 h-36 bg-gray-300 rounded" />
      </div>

      {/* Première rangée de boutons (Up / Down) */}
      <div tw="flex gap-4 w-full">
        <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2">
          <div tw="w-5 h-5 bg-gray-300 rounded" />
          <div tw="w-16 h-4 bg-gray-300 rounded" />
        </div>
        <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2">
          <div tw="w-5 h-5 bg-gray-300 rounded" />
          <div tw="w-20 h-4 bg-gray-300 rounded" />
        </div>
      </div>

      {/* Deuxième rangée de boutons (Open / Close) */}
      <div tw="flex gap-4 w-full">
        <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2">
          <div tw="w-5 h-5 bg-gray-300 rounded" />
          <div tw="w-16 h-4 bg-gray-300 rounded" />
          <div tw="w-5 h-5 bg-gray-300 rounded" />
        </div>
        <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2">
          <div tw="w-5 h-5 bg-gray-300 rounded" />
          <div tw="w-16 h-4 bg-gray-300 rounded" />
          <div tw="w-5 h-5 bg-gray-300 rounded" />
        </div>
      </div>

      {/* Bouton Déployer */}
      <div tw="w-full h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center">
        <div tw="w-24 h-4 bg-gray-300 rounded" />
      </div>

      {/* Bouton Replier */}
      <div tw="w-full h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center">
        <div tw="w-20 h-4 bg-gray-300 rounded" />
      </div>

      {/* Troisième rangée de boutons (Pause / Reset) */}
      <div tw="flex gap-4 w-full">
        <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2">
          <div tw="w-5 h-5 bg-gray-300 rounded" />
          <div tw="w-16 h-4 bg-gray-300 rounded" />
        </div>
        <div tw="flex-1 h-12 bg-gray-200 rounded-xl animate-pulse flex items-center justify-center gap-2">
          <div tw="w-5 h-5 bg-gray-300 rounded" />
          <div tw="w-16 h-4 bg-gray-300 rounded" />
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
